import { Box, Typography } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import { PropsWithChildren } from 'react';
import { Section } from '.';

interface ContentProps extends PropsWithChildren {
	sx?: SxProps;
}

export const Content = ({ children, sx }: ContentProps) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				paddingLeft: { xs: '15px', md: '9rem' },
				...sx
			}}
		>
			{children}
		</Box>
	);
};

export const ContentWSectionHeading = ({
	children,
	heading,
	...props
}: ContentProps & { heading: string }) => {
	return (
		<>
			<Content {...props}>
				<Section sx={{ marginTop: '22px' }} heading={heading}>
					{children}
				</Section>
			</Content>
		</>
	);
};

export const Chart = ({ children, sx }: ContentProps) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				paddingLeft: { xs: 0, md: '6rem' },
				...sx
			}}
		>
			{children}
		</Box>
	);
};

interface ChartWContentProps {
	text?: React.ReactNode;
	chart?: React.ReactNode;
}

export const ChartWContent = ({ text, chart }: ChartWContentProps) => {
	return (
		<>
			<Chart sx={{ marginTop: { xs: '22px', md: '33px' } }}>{chart}</Chart>
			<Content>
				<Section sx={{ marginTop: { xs: '32px', md: '72px' } }}>
					<Typography level='body1'>{text}</Typography>
				</Section>
			</Content>
		</>
	);
};
